import axios from "axios";
import {Base_URL} from "../url"

export const fetchOfficeMaster = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Office/OfficeGetData`);
    console.log(response)
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching office master data!";
  }
};

export const downloadOfficeDataExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/Office/DownloadOfficeDataExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob' // Important for file downloads
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading office data!";
  }
};